import { render, staticRenderFns } from "./SettingsPanel.vue?vue&type=template&id=15c1aeb2&scoped=true"
import script from "./SettingsPanel.vue?vue&type=script&lang=ts"
export * from "./SettingsPanel.vue?vue&type=script&lang=ts"
import style0 from "./SettingsPanel.vue?vue&type=style&index=0&id=15c1aeb2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c1aeb2",
  null
  
)

export default component.exports